/** Standard print resolution used for PSD mockup canvas pixel ↔ inch conversion. */
export const MOCKUP_PRINT_DPI = 300;

export function canvasPixelsToInches(px: number): number {
  return px / MOCKUP_PRINT_DPI;
}

export function inchesToCanvasPixels(inches: number): number {
  return inches * MOCKUP_PRINT_DPI;
}

export function formatInches(inches: number): string {
  return inches.toFixed(2);
}

/** Human-readable size for mockup-generator Printing Details (`logo_size`). */
export function formatLogoSizeLabel(widthInches: number, heightInches: number): string {
  return `${formatInches(widthInches)} X ${formatInches(heightInches)} Inches`;
}
